import type { Layer } from "leaflet";
import type { FmMapLayerId } from "./FmMapWorkspaceRoot.types";

type DomBackedLeafletLayer = Layer & {
  getElement?: () => HTMLElement | SVGElement | null;
};

export interface FmMapLayerDomMarker {
  layerId: FmMapLayerId;
  featureId?: string;
  selected?: boolean;
  testId?: string;
}

/** Registered-renderer DOM contract for browser access to governed map layers. */
export function markMapLayerElement(
  layer: Layer,
  marker: FmMapLayerDomMarker,
): void {
  const applyMarker = () => {
    const element = (layer as DomBackedLeafletLayer).getElement?.();
    if (!element) return;
    element.dataset.fmMapLayer = marker.layerId;
    if (marker.featureId !== undefined) {
      element.dataset.fmMapFeatureId = marker.featureId;
    }
    if (marker.selected !== undefined) {
      element.dataset.fmMapSelected = String(marker.selected);
    }
    if (marker.testId !== undefined) {
      element.setAttribute('data-testid', marker.testId);
    }
  };
  applyMarker();
  layer.on("add", applyMarker);
}
